import React from 'react'
import styled from 'styled-components'
import { device } from './Breakpoints'
import { colors } from './Colors'
import ContactForm from '../components/ContactForm'
import imgCentral from '../icons/centralate.svg'
import imgSac from '../icons/icon-sac-planos.svg'
import convenios from '../services/convenios.json'
import planos from '../services/planos.json'

class PageHeaderPlanos extends React.Component {
  constructor(props) {
    super()
    this.state = {
      ...props,
    }
  }

  setPlanosReady(CodigoConvenio) {
    const filterPlanos = planos.ListaPlanos.filter(
      plano => plano.CodigoConvenio === CodigoConvenio
    )
    const newPlanos =
      Array.isArray(filterPlanos) && filterPlanos.length ? filterPlanos : ''
    this.setState({
      planosReady: true,
      apiPlanos: newPlanos,
    })
  }

  render() {
    const {
      title = 'Página sem título',
      content = 'Página sem conteúdo',
      image,
      color = 'verde',
      height = '168px',
      imgWidth = '45%',
      bottom = '-66px',
      right = '0px',
      overflow = 'hidden',
      titleWidth = '650px',
      apiConvenios = convenios.ListaPlanos,
      apiPlanos = '',
      planosReady = false,
    } = this.state

    const handleBgColor = () => {
      switch (color) {
        case 'azul':
          return colors.azulGradiente
        case 'azulReverso':
          return colors.azulGradienteReverso
        case 'verde':
          return colors.verdeGradiente
        case 'verdeReverso':
          return colors.verdeGradienteReverso
        case 'laranja':
          return colors.laranjaGradiente
        case 'laranjaReverso':
          return colors.laranjaGradienteReverso
        case 'lilas':
          return colors.lilasGradiente
        case 'lilasReverso':
          return colors.lilasGradienteReverso
        default:
          return colors.branco
      }
    }
    const handleBorderColor = () => {
      switch (color) {
        case 'branco-lilas':
          return colors.lilas
        case 'branco-verde':
          return colors.verde
        default:
          return colors.branco
      }
    }
    const handleContentColor = () => {
      switch (color) {
        case 'branco-lilas':
          return colors.lilas
        case 'branco-verde':
          return colors.cinza
        default:
          return colors.branco
      }
    }
    const handleTitleColor = () => {
      switch (color) {
        case 'branco-lilas':
          return colors.lilas
        case 'branco-verde':
          return colors.cinza
        case 'laranjaReverso':
          return colors.amarelo
        default:
          return colors.branco
      }
    }
    const Header = styled.section`
      padding: 3em 2em;
      position: relative;
      background: ${props => handleBgColor(props.color)}!important;
      margin-top: 0px;
      overflow: ${() => {
        return overflow
      }};
      h2 {
        font-weight: normal;
        @media ${device.mobileL} {
          font-size: 1.2em;
          line-height: 1.1em;
        }
      }
      @media ${device.mobileL} {
        /* padding: 154px 2em 2em !important;*/
        padding: 2em 2em !important;
        overflow: visible;
        margin-top: 0;
      }
      .image {
        position: absolute !important;
        display: block;
        height: auto;
        width: ${props => props.imgWidth};
        right: ${() => {
          return right
        }};
        bottom: ${() => {
          return bottom
        }};
        width: ${() => {
          return imgWidth
        }};
        z-index: 3;
        @media ${device.tablet} {
          display: none;
        }
        @media ${device.mobileL} {
          display: none;
        }
      }
      .imageM {
        display: none;
        width: 100%;
        right: 0px;
        top: 0px;
        @media ${device.mobileL} {
          display: block;
        }
      }
      > div {
        @media ${device.laptop} {
          width: 100%;
          font-weight: normal;
          font-size: 1em;
          .inner {
            width: auto;
          }
        }
      }
      div {
        @media ${device.mobileL} {
          width: 100%;
          font-weight: normal;
          font-size: 0.8em;
          margin-left: 0;
          box-sizing: border-box;
        }
      }
      .sac {
        padding: 2em 2em 0;
        @media ${device.mobileL} {
          padding: 0;
          margin-top: 2em;
        }
        p {
          color: #ffffff;
          font-size: 0.7em;
          @media ${device.mobileL} {
            font-size: 1em;
          }
        }
        .colums {
          display: flex;
          justify-content: space-between;
          margin-top: 2em;
          @media ${device.mobileL} {
            flex-wrap: wrap;
          }
          div {
            width: 50%;
            box-sizing: border-box;
            @media ${device.mobileL} {
              width: 100%;
              font-size: 2em;
              text-align: left;
            }
            :first-child {
              max-width: 38%;
              padding-left: 3em;
              @media ${device.mobileL} {
                max-width: 100%;
                padding-left: 0em;
              }
            }
            h3 {
              font-size: 1em;
              color: #f4edc6;
              position: relative;
              margin-bottom: 0.5em;
              @media ${device.mobileL} {
                text-align: left;
                padding-left: 3em;
                margin: 1em 0;
              }
              img {
                position: absolute;
                left: -3em;
                top: 0;
                @media ${device.mobileL} {
                  left: 0em;
                }
              }
            }
            span {
              color: #f4edc6;
            }
            p {
              margin-bottom: 0px;
            }
            form {
              display: flex;
              flex-wrap: wrap;
              justify-content: space-between;
              fieldset {
                width: 100%;
              }

              .half {
                width: 49%;
                box-sizing: border-box;
                @media ${device.mobileL} {
                  width: 100%;
                }
              }
              textarea {
                display: block;
                padding: 10px;
                margin-top: 0;
                width: 100% !important;
                margin-top: 8px;
                height: 137px;
                resize: none;
                border: none;
                border-radius: 5px;
                font-family: 'Santral', Arial, Helvetica, sans-serif;
                font-size: 0.8em;
                ::placeholder {
                  color: #b1b1b1;
                }
                @media ${device.mobileL} {
                  margin-top: 8px !important;
                  width: 100% !important;
                }
              }
              input,
              select {
                flex-direction: row;
                display: block;
                width: 100%;
                height: 40px;
                margin-top: 8px;
                font-family: 'Santral', Arial, Helvetica, sans-serif;
                font-size: 0.8em;
                border: none;
                border-radius: 4px;
                padding: 0 10px;
                box-sizing: border-box;
                ::placeholder {
                  color: #b1b1b1;
                }
                @media ${device.mobileL} {
                  width: 100%;
                }
              }
              /**
              Target IE11
              */
              select::-ms-expand {
                display: none;
              }
              button {
                border: none;
                border-radius: 25px;
                height: 45px;
                width: 30%;
                color: white;
                text-transform: uppercase;
                background: ${colors.inputGradiente};
                font-family: 'Santral', Arial, Helvetica, sans-serif;
                margin-top: 10px;
                cursor: pointer;
                :hover {
                  background: ${colors.verdeGradienteReverso};
                }
                @media ${device.mobileL} {
                  width: 60%;
                  margin: 1em auto;
                }
              }
            }
          }
        }
      }
      .inner {
        border-bottom: 6px ${props => handleBorderColor(props.color)} solid;
        border-left: 6px ${props => handleBorderColor(props.color)} solid;
        border-right: 6px ${props => handleBorderColor(props.color)} solid;
        padding: 1em 2em;
        margin: 0;
        position: relative;
        min-height: ${() => {
          return height
        }};
        :before {
          content: '';
          background: ${props => handleBorderColor(props.color)};
          width: 2%;
          height: 6px;
          position: absolute;
          left: 0;
          top: 0;
          z-index: 2;
        }
        @media ${device.mobileL} {
          border-top: 8px ${props => handleBorderColor(props.color)} solid;
          border-left: 8px ${props => handleBorderColor(props.color)} solid;
          border-right: 8px ${props => handleBorderColor(props.color)} solid;
          border-bottom: none;
          display: block;
          padding: 2em 2em;
          :before {
            content: '';
            background: ${props => handleBorderColor(props.color)};
            width: 15px;
            height: 8px;
            position: absolute;
            left: -1px;
            bottom: 0;
            top: inherit;
            z-index: 2;
          }
          :after {
            content: '';
            background: ${props => handleBorderColor(props.color)};
            width: 60px;
            height: 8px;
            position: absolute;
            right: -1px;
            bottom: 0;
            top: inherit;
            z-index: 2;
          }
        }
        img {
          height: auto;
          width: ${props => props.imgWidth};
        }

        .convenios {
          width: 35%;
          @media ${device.tablet} {
            width: 100%;
          }
          @media ${device.mobileL} {
            width: 100%;
            font-size: 2em;
          }

          p {
            font-size: 0.7em;
            color: #ffffff;
            margin: 1em 0;
          }
          form {
            display: flex;
            flex-wrap: wrap;
            @media ${device.mobileL} {
              width: 100%;
              margin-left: 0;
              box-sizing: border-box;
              font-size: 0.8em;
            }
          }
          input,
          select {
            flex-direction: row;
            display: block;
            width: 100%;
            height: 40px;
            margin-top: 8px;
            font-family: 'Santral', Arial, Helvetica, sans-serif;
            font-size: 0.8em;
            border: none;
            border-radius: 4px;
            padding: 0 44px 0 10px;
            box-sizing: border-box;
            ::placeholder {
              color: #b1b1b1;
            }
            @media ${device.mobileL} {
              width: 100%;
            }
          }
          /**
              Target IE11
              */
          select::-ms-expand {
            display: none;
          }
          .planos {
            background: #ffffff;
            border-radius: 4px;
            margin-top: 8px;
            width: 100%;
            padding: 0.5em;
            strong {
              font-size: 0.8em;
              font-weight: normal;
              font-family: 'Santral', Arial, Helvetica, sans-serif;
              color: #000000;
            }
            ul {
              margin: 0;
              padding: 0;
              max-height: 200px;
              overflow-y: scroll;
              li {
                padding: 1em;
                list-style: none;
                border-bottom: 1px #dedef2 solid;
                font-size: 0.7em;
                margin-bottom: 0;
                :last-child {
                  border: none;
                }
              }
            }
          }
        }
        .content {
          font-size: 0.8em;
          width: 50%;
          line-height: 1.6em;
          color: ${props => handleContentColor(props.color)};
          @media ${device.tablet} {
            width: 100%;
            font-size: 1.5em;
            text-align: left;
          }
          @media ${device.mobileL} {
            width: 100%;
            font-size: 1.5em;
            text-align: left;
          }
          a {
            color: ${props => handleContentColor(props.color)};
          }
        }
        h1 {
          font-weight: normal;
          font-family: 'Santral Bold', Arial, Helvetica, sans-serif;
          color: ${props => handleTitleColor(props.color)};
          line-height: 1em;
          margin-top: -52px;
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          div.title {
            max-width: ${() => {
              return titleWidth
            }};
          }
          :after {
            content: '';
            background: ${props => handleBorderColor(props.color)};
            height: 6px;
            flex-grow: 1;
            margin: 32px -40px 0px 10px;
          }
          @media ${device.mobileL} {
            :after {
              display: none;
            }
          }
          @media ${device.mobileL} {
            text-align: left;
            margin-top: 0px;
          }
        }
        p {
          font-size: 0.9em;
          width: 100%;
          max-width: 560px;
          line-height: 1.6em;
          @media ${device.mobileL} {
            width: 100%;
            text-align: left;
            line-height: 1.3em;
          }
        }
        @media ${device.mobileL} {
          margin: 0;
          h2 {
            position: initial;
            text-align: left;
            padding: 0;
          }
        }
      }
    `
    const AlignCenter = styled.div`
      max-width: 1114px;
      margin: auto;
      @media ${device.mobileL} {
        max-width: 100%;
        text-align: center;
      }
    `

    return (
      <Header className={color}>
        <img src={image} alt={title} className="imageM" />
        <AlignCenter>
          <div className="inner">
            <h1>
              <div className="title">{title}</div>
            </h1>
            <div
              className="content"
              dangerouslySetInnerHTML={{ __html: content }}
            />
            <div className="convenios">
              <p>Selecione um convênio e confira os planos atendidos:</p>

              <form>
                <select onChange={e => this.setPlanosReady(e.target.value)}>
                  <option>Selecione seu convênio</option>
                  {apiConvenios.map(convenio => (
                    <option
                      key={convenio.CodigoConvenio}
                      value={convenio.CodigoConvenio}
                    >
                      {convenio.NomeConvenio}
                    </option>
                  ))}
                </select>
                {planosReady ? (
                  <div className="planos">
                    <strong>Planos atendidos</strong>
                    <ul>
                      {apiPlanos !== '' ? (
                        apiPlanos.map(plano => (
                          <li key={plano.CodigoPlano}>{plano.NomePlano}</li>
                        ))
                      ) : (
                        <li key="1">Nenhum plano disponível</li>
                      )}
                    </ul>
                  </div>
                ) : (
                  ''
                )}
              </form>
              <p>
                Para conferir as coberturas do seu plano, contate diretamente a
                operadora.
              </p>
            </div>
            <img src={image} alt={title} className="image" />
          </div>
          <div className="sac">
            <p>
              Se preferir, entre em contato conosco pelo telefone abaixo ou
              envie-nos uma mensagem:
            </p>
            <div className="colums">
              <div>
                <h3>
                  <img src={imgCentral} alt="Saiba mais" />
                  (11) 5080-6000
                </h3>
                <span>(Tecle opção 1)</span>
                <p>De 2ª a 6ª feira, das 08h às 20h.</p>
                <p>Sábados, das 08h às 12h.</p>
              </div>
              <div>
                <h3>
                  <img src={imgSac} alt="Saiba mais" />
                  Central de Relacionamento com o Cliente
                </h3>
                <ContactForm />
              </div>
            </div>
          </div>
        </AlignCenter>
      </Header>
    )
  }
}

export default PageHeaderPlanos
